import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useMemo } from 'react';
import { Field } from 'redux-form';
import { propBool, propId, propShape, propStr, } from '@/helpers/custom-prop-types';
import { rfpOrderValidate } from '@/validate/custom/rfp/client/order';
import UserBox from '../../User/UserBox';
import OrderInputRadio from './OrderInputRadio';
import OrderInputRow from './OrderInputRow';
/**
 * TODO: TS化 & tailwind化
 */
const OrderOfferRow = (props) => {
    const { checked, offer, radioName, radioValue } = props;
    const { first_name: firstName, id, is_show_detail_page: isShowDetailPage, last_name: lastName, organization_name: organizationName, photo, professional_id: professionalId, type: propType, url_code: urlCode, } = offer;
    const type = useMemo(() => parseInt(propType, 10), [propType]);
    return (_jsxs("div", Object.assign({ className: 'input_contents_row input_contents_offers_row' }, { children: [_jsx("div", Object.assign({ className: 'input_contents_row_head field' }, { children: _jsx(Field, { checked: checked, component: OrderInputRadio, name: radioName, rightComponent: _jsx(UserBox, { firstName: firstName, id: professionalId, isShowDetailPage: isShowDetailPage, lastName: lastName, organizationName: organizationName, photo: photo, type: type, urlCode: urlCode }), setValue: radioValue, validate: rfpOrderValidate.select }) })), _jsx(OrderInputRow, { checked: checked, identifier: `${id}`, placeholder: 'よろしければ、提案チームの印象や、決め手になったポイントを記入ください', showDates: true })] })));
};
OrderOfferRow.propTypes = {
    checked: propBool().isRequired,
    offer: propShape().isRequired,
    radioName: propStr().isRequired,
    radioValue: propId().isRequired,
};
export default OrderOfferRow;
